import React from "react";
import moment from "moment";
import { ChantSelect } from "../../../../CommonComponents";
import { useWatch, useController } from "react-hook-form";

const Months = {
  Jan: 31,
  Feb: 29,
  Mar: 31,
  Apr: 30,
  May: 31,
  Jun: 30,
  Jul: 31,
  Aug: 31,
  Sep: 30,
  Oct: 31,
  Nov: 30,
  Dec: 31,
};

const BirthDayField = ({ control, name, value, onChange }) => {
  // Watch the current values from React Hook Form
  const watchedValues = useWatch({
    control,
    name: name,
  });

  // Generate month options
  const monthOptions = Object.keys(Months).map((month) => ({
    value: month,
    label: month,
  }));

  // Generate year options (1923 to current year)
  const yearOptions = Array.from(
    { length: moment().year() - 1922 },
    (_, index) => ({
      value: String(1923 + index),
      label: String(1923 + index),
    }),
  );

  // day field controller — normalizes both "day" and "date" field names
  const { field: dayField } = useController({ control, name: `${name}.day` });
  const currentDay =
    dayField.value || watchedValues?.date || value?.day || value?.date || "";

  // Get current values from watched values or fallback to value prop
  const currentMonth = watchedValues?.month || value?.month || "";

  // Generate date options based on selected month
  const getDateOptions = (month) => {
    if (!month) return [];
    const daysInMonth = Months[month] || 31;
    return Array.from({ length: daysInMonth }, (_, index) => ({
      value: String(index + 1),
      label: String(index + 1),
    }));
  };

  const dateOptions = getDateOptions(currentMonth);

  return (
    <div className="col form-group-constrained">
      <span>Birthday</span>
      <div className="d-flex" style={{ gap: "8px", marginTop: "2px" }}>
        <div style={{ flex: 1 }}>
          <ChantSelect
            control={control}
            name={`${name}.month`}
            allowClear
            placeholder="Month"
            options={monthOptions}
            onChange={(value) => {
              const updatedValue = {
                ...(watchedValues || value || {}),
                month: value,
              };
              onChange?.(updatedValue);
            }}
          />
        </div>
        <div style={{ flex: 1 }}>
          <ChantSelect
            allowClear
            placeholder="Day"
            options={dateOptions}
            value={currentDay || undefined}
            onChange={(val) => {
              dayField.onChange(val);
              onChange?.({ ...(watchedValues || {}), day: val });
            }}
          />
        </div>
        <div style={{ flex: 1 }}>
          <ChantSelect
            control={control}
            name={`${name}.year`}
            allowClear
            placeholder="Year"
            options={yearOptions}
            onChange={(value) => {
              const updatedValue = {
                ...(watchedValues || value || {}),
                year: value,
              };
              onChange?.(updatedValue);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BirthDayField;
